import { z } from "zod";
/**
 * Note Validation Schemas
 */
/**
 * Schema for creating a note
 */
export const createNoteSchema = z.object({
    resultId: z.number().int().positive(),
    content: z.string().min(1).max(5000).trim(),
});
/**
 * Schema for updating a note
 */
export const updateNoteSchema = z.object({
    content: z.string().min(1).max(5000).trim(),
});
/**
 * Schema for deleting a note
 */
export const deleteNoteSchema = z.object({
    id: z.number().int().positive(),
});
/**
 * Schema for getting notes by result
 */
export const getNotesByResultSchema = z.object({
    resultId: z.number().int().positive(),
});
//# sourceMappingURL=note.schema.js.map